<!-- <template>
  <v-card
    class="mx-auto"
    max-width="600"
  >
    <v-toolbar
      color="primary"
      dark
    >
      <v-toolbar-title>Menús</v-toolbar-title>
    </v-toolbar>

    <v-container fluid>
      <v-row dense>
        <v-col cols="6">
          <v-card
            :to="{ name: 'clasproductos' }">
            <v-img
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              class="white--text align-end"
              height="200px"
              src="https://www.contenidoweb.info/images/clasificacion-de-documentos.jpg"
            >
              <v-card-title>Clasificar Productos</v-card-title>
            </v-img>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card :to="{ name: 'operaciones' }">
            <v-img
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              class="white--text align-end"
              height="200px"
              src="https://cdn-mexico.unir.net/wp-content/uploads/2018/09/maestria-en-direccion-de-operaciones-y-calidad_p2.jpg"
            >
              <v-card-title>Operaciones</v-card-title>
            </v-img>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="6">
          <v-card :to="{ name: 'marketing' }">
            <v-img
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              class="white--text align-end"
              height="200px"
              src="https://static.wixstatic.com/media/d6aa0f_3fa6512987c44c05b3f8a141a596d60a~mv2.jpg"
            >
              <v-card-title>Marketing</v-card-title>
            </v-img>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card :to="{ name: 'configuracion' }">
            <v-img
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              class="white--text align-end"
              height="200px"
              src="https://img.freepik.com/vector-gratis/ilustracion-concepto-configuracion_114360-382.jpg?size=338&ext=jpg"
            >
              <v-card-title>Configuración</v-card-title>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
 -->
<template>
  <div class="home" align="center">
    <!-- <img alt="Vue logo" src="logo.png" width="50%"> -->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {
  }
}
</script>
